import 'css-chunksrc/client/common/resourceAllocationMenu/checkbox/styles.scss';export default {
  "checkbox": "_checkbox_u0qai_1",
  "checked": "_checked_u0qai_13"
};